export default __webpack_public_path__ + "static/media/jitsi.30fcc86d.png";